import {
    SIGNUP_ERROR,
    SIGNUP_SUCCESS,
    SUBMIT_SIGNUP,
    FINISH_SIGNUP,
    FINISH_SIGNUP_ERROR,
    FINISH_SIGNUP_SUBMIT,
    FINISH_SIGNUP_SUCCESS,
    FINISH_SIGNUP_STEP_SUCCESS
} from '../actionTypes'

import { request, API_URL, getInfoLocalStorage } from '../../utils/api'
import { login } from './login';
import moment from 'moment';

export const signup = (form) => dispatch => {
    let tipoPessoa
    form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
            dispatch(submitSignup())
            try {
                const { code, message } = await request('users/signup', 'POST', {
                    ...values,
                    tipo: 3,
                    tipoPessoa: 1,
                    referralCode: values.referralCode || null
                })
                if (code === 201) {
                    dispatch(signupSuccess())
                    const url = '/cadastro/concluido'
                    window.history.pushState({}, '', url)
                    // dispatch(login({
                    //     validateFieldsAndScroll: fn => fn(null, {
                    //         email: values.email,
                    //         password: values.senha
                    //     })
                    // }))
                } else {
                    dispatch(signupError(message))
                }
            } catch(e) {
                console.log(e)
                dispatch(signupError())
            }
        }
    })
}

export const signupSuccess = () => ({
    type: SIGNUP_SUCCESS
})

export const signupError = (message = 'Ops! Parece que há inconsistências nos dados fornecidos!') => ({
    type: SIGNUP_ERROR,
    payload: {
        message
    }
})

export const submitSignup = () => ({
    type: SUBMIT_SIGNUP
})

export const finishSignup = () => ({
    type: FINISH_SIGNUP
})

export const putSignUp = (form, file, step, userid) => async dispatch => {
    // Make file upload optional for both steps
    form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
            try {
                dispatch(putSignUpSubmit())
                const formData = new FormData()
                if(step === 1) {
                    formData.append('nome', values.nome)
                    formData.append('telefone', values.telefone)
                    formData.append('email', values.email)
                    let nascimento = values.nascimento;
                    if (nascimento && nascimento.format) {
                      nascimento = nascimento.format('DD/MM/YYYY');
                    } else if (typeof nascimento === 'string') {
                      nascimento = moment(nascimento).format('DD/MM/YYYY');
                    }
                    formData.append('nascimento', nascimento);
                    formData.append('cpf', values.cpf)
                    formData.append('rg', values.rg)
                    formData.append('nomeMae', values.nomeMae)
                } else {
                    formData.append('cep', values.cep)
                    formData.append('cidade', values.cidade)
                    formData.append('estado', values.estado)
                    formData.append('endereco', values.endereco)
                    formData.append('numero', values.numero)
                    formData.append('complemento', values.complemento)
                    formData.append('bairro', values.bairro)
                }
                // Only append file if it exists
                if (file) {
                    formData.append('file', file)
                }
                formData.append('step', step)
                const req = await fetch(`${API_URL}users/finish-signup/${userid}`, {
                    method: 'PUT',
                    body: formData,
                    headers: {
                        'Authorization': `Bearer ${getInfoLocalStorage().token}`
                    }
                })
                const response = await req.json()
                if (response.code === 201) {
                    dispatch(putSignUpSuccess(step === 1 ? 2 : 3))
                    if(step === 2) {
                        const url = '/finalizar-cadastro/concluido'
                        window.history.pushState({}, '', url)
                    }
                } else {
                    dispatch(putSignUpError(response.message))
                }
            } catch(e) {
                console.log(e)
                dispatch(putSignUpError('Houve um erro ao finalizar seu cadastro'))
            }
        }
    })
}

export const putSignUpSuccess = (step) => ({
    type: FINISH_SIGNUP_SUCCESS,
    payload: {
        step
    }
})

export const putSignUpError = (message = 'Ops! Parece que há inconsistências nos dados fornecidos!') => ({
    type: FINISH_SIGNUP_ERROR,
    payload: {
        message
    }
})

export const putSignUpSubmit = () => ({
    type: FINISH_SIGNUP_SUBMIT
})

export const changeSignUpStep = (step) => ({
    type: FINISH_SIGNUP_STEP_SUCCESS,
    payload: {
        step
    }
})